import React, { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import TeamSquad from "./TeamSquad";
import { loadStyles } from "../../../utils/cssLoader";

const SquadWrp = ({
  data,
  teamId,
  baseUrl,
  dataClient,
  loadCSS,
  title,
  websiteBaseUrl,
  dataPath,
}) => {
  const [clientData, setClientData] = useState(null);
  const [teamData, setTeamData] = useState(dataClient ? null : data?.squad);
  const [leagueSelectedId, setLeagueSelectedId] = useState(
    dataClient ? null : data?.league?.data?.[0]?.id
  );

  const items = dataClient ? clientData?.league : data?.league;

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
      setTeamData(parsed?.squad);
      setLeagueSelectedId(parsed?.league?.data?.[0]?.id);
    } catch (error) {
      console.error("Failed to parse client data:", error);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("team");
    }
  }, [loadCSS]);

  useEffect(() => {
    if (!leagueSelectedId || !teamId || !dataClient) return;

    const fetchTableData = async () => {
      try {
        const res = await fetch(
          `${baseUrl}/football/stat/team/${teamId}/lineup?leagueId=${leagueSelectedId}`,
          {
            headers: {
              Token: process.env.REACT_APP_API_TOKEN,
            },
          }
        );
        if (!res.ok) throw new Error(res.statusText);

        const json = await res.json();
        setTeamData(json || null);
      } catch (err) {
        console.error("Failed to fetch squad:", err);
      }
    };

    fetchTableData();
  }, [leagueSelectedId, teamId, dataClient]);

  return (
    <>
      {title && <h1>{title}</h1>}

      <Dropdown
        items={items?.data}
        defaultValue={leagueSelectedId}
        setLeagueSelectedId={setLeagueSelectedId}
      />
      <TeamSquad
        teamSquad={teamData?.data}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        dataClient={dataClient}
      />
    </>
  );
};

export default SquadWrp;
